import { useEffect, useState } from 'react'
import { useLocalForageKey } from '../../../../utils/local-storage/useLocalForageKey.hooks'

export const useStoreSessionToken = (token: string | undefined) => {
  const [tokenStored, setTokenStored] = useState<boolean>(false)

  const { setData: storeSessionData } = useLocalForageKey<{
    token?: string
  }>('session')

  useEffect(() => {
    async function saveSessionData() {
      if (token) {
        await storeSessionData({ token })
        setTokenStored(true)
      }
    }

    saveSessionData()
  }, [token, storeSessionData])

  return {
    completed: tokenStored,
  }
}
